import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default gsap;

export { gsap, ScrollTrigger };

// Selten genutzte Plugins bewusst NICHT hier registrieren: SplitText nur in
// StickyText.vue, Flip nur in animations/sectionStage.js — beide importieren das
// Plugin lokal aus "gsap/<Plugin>" und registrieren es dort (registerPlugin ist
// idempotent). So bleiben ~137 KiB ungenutzte gsap-Plugins (GSDevTools+Draggable,
// ScrollSmoother, MorphSVG, DrawSVG, TextPlugin, ScrollToPlugin, SplitText, Flip)
// aus dem Haupt-Bundle. Wer eines dieser Plugins braucht, importiert es lokal.
